import { Component, OnInit } from '@angular/core';
import { SportsIllustratedAuthService } from 'src/app/shared/components/providers/sports-illustrated/sports-illustrated-service/sports-illustrated-auth.service';

@Component({
  selector: 'fgb-sports-illustrated-user-login',
  templateUrl: './sports-illustrated-user-login.component.html',
  styleUrls: ['./sports-illustrated-user-login.component.scss'],
})
export class SportsIllustratedUserLoginComponent implements OnInit {
  constructor(private sportsIllustratedService: SportsIllustratedAuthService) {}

  ngOnInit() {}

  loginSportsIllustrated() {
    this.sportsIllustratedService.login().toPromise();
  }
}
